import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import DashboardIcon from "../../assets/images/icon/dashboardIcon.svg";
import ImportDataIcon from "../../assets/images/icon/importDataIcon.svg";
import ExportDataIcon from "../../assets/images/icon/exportDataIcon.svg";
import ShrinkIcon from "../../assets/images/icon/shrinkIcon.svg";
import SettingIcon from "../../assets/images/icon/settingIcon.svg";
import WarehouseIcon from "../../assets/images/icon/warehouseIcon.svg";
import DocumentIcon from "../../assets/images/icon/documentIcon.png";
import useCancelModal from "../../lib/hooks/useCancelModal";
// import {
//   ArrowRightOutlined,
//   CloudUploadOutlined,
//   UploadOutlined,
// } from "@ant-design/icons";

import { Layout, Menu } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import packageJson from "../../../package.json";
import { PAGES, PERMISSION_DATA } from "../../lib/const";
import useAuth from "../../lib/hooks/useAuth";
import usePermission from "../../lib/hooks/usePermisson";
import { routes } from "../../routes";
const { Sider } = Layout;

const rootSubmenuKeys = [routes.customer, routes.user_management];

const permissionAdmin = "a23126cb-5ef4-0c98-e3bc-840d81135073";

const Sidebar = () => {
  const navigate = useNavigate();
  const history = useLocation();
  const { setPreviousPage, setOpenCancelModal } = useCancelModal();
  const [collapsed, setCollapsed] = useState(false);
  const [openKeys, setOpenKeys] = useState([]);
  const [current, setCurrent] = useState("");
  const [isDuring, setIsDuring] = useState(false);
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get("tab");

  const { auth } = useAuth();
  const [roleUser1, isAll1] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.CURRENT_CUSTOMER
  );
  const [roleUser2, isAll2] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.FUTURE_CUSTOMER
  );
  const [roleUser3, isAll3] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.STAKEHOLDER
  );
  const [roleUser4, isAll4] = usePermission(
    PERMISSION_DATA.APPLICATION,
    PAGES.TOUCHPOINT
  );
  // const [roleUser5, isAll5] = usePermission(
  //   PERMISSION_DATA.APPLICATION,
  //   PAGES.COMPETITOR
  // );

  const checkCurrentURL = useCallback(() => {
    const url = window.location.href;
    const myArray = url.split("/");
    for (let i = 0; i < myArray.length; i++) {
      if (
        myArray[i] === "add" ||
        myArray[i] === "edit" ||
        myArray[i] === "update"
      ) {
        setIsDuring(true);
      }
    }
  }, [setIsDuring]);

  useEffect(() => {
    checkCurrentURL();
  }, [checkCurrentURL]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  function getItem(label, key, icon, children, theme) {
    return {
      key,
      icon,
      children,
      label,
      theme: "light",
    };
  }

  const items = [
    getItem(
      <div
        onClick={() => {
          setCollapsed(true);
          if (isDuring) {
            setPreviousPage(routes.dashboard);
            setOpenCancelModal(true);
          } else {
            navigate(routes.dashboard);
          }
        }}
      >
        หน้าหลัก
      </div>,
      routes.dashboard,
      <img
        src={DashboardIcon}
        width={16}
        alt="หน้าหลัก"
        onClick={() => setCollapsed(true)}
      />
    ),
    getItem(
      "คลังข้อมูล",
      routes.customer,
      <img src={WarehouseIcon} width={18} alt="คลังข้อมูล" />,
      [
        (roleUser1[0]?.isCreate ||
          roleUser1[0]?.isEdit ||
          roleUser1[0]?.isDelete ||
          roleUser1[0]?.isView ||
          roleUser1[0]?.isExport) &&
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.customer + `?menu=customer&tab=current`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(routes.customer + `?menu=customer&tab=current`);
                }
              }}
            >
              ข้อมูลลูกค้าปัจจุบัน
            </div>,
            "current"
          ),
        (roleUser2[0]?.isCreate ||
          roleUser2[0]?.isEdit ||
          roleUser2[0]?.isDelete ||
          roleUser2[0]?.isView ||
          roleUser2[0]?.isExport) &&
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.customer + `?menu=customer&tab=future`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(routes.customer + `?menu=customer&tab=future`);
                }
              }}
            >
              ข้อมูลลูกค้าอนาคต
            </div>,
            "future"
          ),
          /*
          getItem(
              <div
                onClick={() => {
                  if (isDuring) {
                    setPreviousPage(
                      routes.customer + `?menu=customer&tab=customercompetitor_domestic`
                    );
                    setOpenCancelModal(true);
                  } else {
                    navigate(routes.customer + `?menu=customer&tab=customercompetitor_domestic`);
                  }
                }}
              >
                ข้อมูลลูกค้าของคู่แข่งในประเทศ
              </div>,
              "Customer_Competitor_Domestic"
          ),
          getItem(
              <div
                onClick={() => {
                  if (isDuring) {
                    setPreviousPage(
                      routes.customer + `?menu=customer&tab=customercompetitor_international`
                    );
                    setOpenCancelModal(true);
                  } else {
                    navigate(routes.customer + `?menu=customer&tab=customercompetitor_international`);
                  }
                }}
              >
                ข้อมูลลูกค้าของคู่แข่งต่างประเทศ
              </div>,
              "Customer_Competitor_International"
          ),
          */
        (roleUser3[0]?.isCreate ||
          roleUser3[0]?.isEdit ||
          roleUser3[0]?.isDelete ||
          roleUser3[0]?.isView) &&
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.customer + `?menu=customer&tab=stakeholder`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(routes.customer + `?menu=customer&tab=stakeholder`);
                }
              }}
            >
              ข้อมูลผู้มีส่วนได้ส่วนเสีย
            </div>,
            "stakeholder"
          ),
        (roleUser4[0]?.isCreate ||
          roleUser4[0]?.isEdit ||
          roleUser4[0]?.isDelete ||
          roleUser4[0]?.isView) &&
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.customer + `?menu=customer&tab=touchpoint`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(routes.customer + `?menu=customer&tab=touchpoint`);
                }
              }}
            >
              ข้อมูล Touch Point
            </div>,
            "touchpoint"
          ),
        getItem(
          <div
            onClick={() => {
              if (isDuring) {
                setPreviousPage(
                  routes.customer + `?menu=customer&tab=competitor`
                );
                setOpenCancelModal(true);
              } else {
                navigate(routes.customer + `?menu=customer&tab=competitor`);
              }
            }}
          >
            ข้อมูลคู่แข่ง
          </div>,
          "competitor"
        ),
        getItem(
          <div
            onClick={() => {
              if (isDuring) {
                setPreviousPage(
                  routes.customer + `?menu=customer&tab=areaUsage`
                );
                setOpenCancelModal(true);
              } else {
                navigate(routes.customer + `?menu=customer&tab=areaUsage`);
              }
            }}
          >
            ข้อมูลการใช้พื้นที่
          </div>,
          "areaUsage"
        ),
        getItem(
          <div
            onClick={() => {
              if (isDuring) {
                setPreviousPage(routes.customer + `?menu=customer&tab=visit`);
                setOpenCancelModal(true);
              } else {
                navigate(routes.customer + `?menu=customer&tab=visit`);
              }
            }}
          >
            ข้อมูลการเยี่ยมชม
          </div>,
          "visit"
        ),
      ]
    ),
    permissionAdmin === auth?.user?.permissionId &&
      getItem(
        <div
          onClick={() => {
            if (isDuring) {
              setPreviousPage(routes.import_file);
              setOpenCancelModal(true);
            } else {
              navigate(routes.import_file);
            }
          }}
        >
          นำเข้าข้อมูล
        </div>,
        routes.import_file,
        <img src={ImportDataIcon} width={18} alt="นำเข้าข้อมูล" />
      ),
    getItem(
      <div
        onClick={() => {
          if (isDuring) {
            setPreviousPage(routes.export_file);
            setOpenCancelModal(true);
          } else {
            navigate(routes.export_file);
          }
        }}
      >
        นำออกข้อมูล
      </div>,
      routes.export_file,
      <img src={ExportDataIcon} width={18} alt="export" />
    ),
      // getItem(
      // <div
      //   onClick={() => {
      //     if (isDuring) {
      //       setPreviousPage(routes.org_chart);
      //       setOpenCancelModal(true);
      //     } else {
      //       navigate(routes.org_chart);
      //     }
      //   }}
      // >
      //   แสดงผังองค์กร
      // </div>,
    //   routes.org_chart,
    //   <img src={ShrinkIcon} width={18} alt="OrgChart" />
    // ) ,
    getItem(
      "รายงานการดำเนินงานตามแผนยุทธศาสตร์",
      routes.progress_performance,
      <img
        src={DocumentIcon}
        width={16}
        alt="รายงานการดำเนินงานตามแผนยุทธศาสตร์"
      />,
      [
        getItem(
          <div
            onClick={() => {
              if (isDuring) {
                setPreviousPage(
                  routes.progress_performance + `?menu=progress&tab=kpi`
                );
                setOpenCancelModal(true);
              } else {
                navigate(
                  routes.progress_performance + `?menu=progress&tab=kpi`
                );
              }
            }}
          >
            แผนยุทธศาสตร์
          </div>,
          "kpi"
        ),
        getItem(
          <div
            onClick={() => {
              if (isDuring) {
                setPreviousPage(
                  routes.progress_performance + `?menu=progress&tab=indicator`
                );
                setOpenCancelModal(true);
              } else {
                navigate(
                  routes.progress_performance + `?menu=progress&tab=indicator`
                );
              }
            }}
          >
            รายงานผลตัวชี้วัด
          </div>,
          "indicator"
        ),
        getItem(
          <div
            onClick={() => {
              if (isDuring) {
                setPreviousPage(
                  routes.progress_performance + `?menu=progress&tab=performance`
                );
                setOpenCancelModal(true);
              } else {
                navigate(
                  routes.progress_performance + `?menu=progress&tab=performance`
                );
              }
            }}
          >
            รายงานผลการดำเนินงานตามแผนปฏิบัติการ
          </div>,
          "performance"
        ),
      ]
    ),
    permissionAdmin === auth?.user?.permissionId &&
      getItem(
        <div>การจัดการผู้ใช้งาน</div>,
        routes.user_management,
        <img src={SettingIcon} width={18} alt="การจัดการผู้ใช้งาน" />,
        [
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.user_management + `?menu=management&tab=user`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(
                    routes.user_management + `?menu=management&tab=user`
                  );
                }
              }}
            >
              การจัดการผู้ใช้งาน
            </div>,
            "user"
          ),
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.user_management + `?menu=management&tab=role`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(
                    routes.user_management + `?menu=management&tab=role`
                  );
                }
              }}
            >
              การจัดการบทบาทและสิทธิ์การเข้าถึง
            </div>,
            "role"
          ),
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.user_management + `?menu=management&tab=staff`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(
                    routes.user_management + `?menu=management&tab=staff`
                  );
                }
              }}
            >
              การจัดการรายชื่อเจ้าหน้าที่จัดทำรายงาน
            </div>,
            "staff"
          ),
           
            getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.user_management + `?menu=management&tab=reportlogin`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(
                    routes.user_management + `?menu=management&tab=reportlogin`
                  );
                }
              }}
            >
              รายงานการใช้ระบบ
            </div>,
            "reportlogin"
          ),
           
           
        ]
      ),
      getItem(
        "รายงานจัดอันดับ",
        routes.voc_report,
        <img
          src={DocumentIcon}
          width={16}
          alt="รายงานจัดอันดับ"
        />,
        [
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.voc_report + `?menu=progress&tab=current`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(
                    routes.voc_report + `?menu=progress&tab=current`
                  );
                }
              }}
            >
              รายงานจัดอันดับลูกค้าปัจจุบัน
            </div>,
            "kpi"
          ),
          getItem(
            <div
              onClick={() => {
                if (isDuring) {
                  setPreviousPage(
                    routes.voc_report + `?menu=progress&tab=future`
                  );
                  setOpenCancelModal(true);
                } else {
                  navigate(
                    routes.voc_report + `?menu=progress&tab=future`
                  );
                }
              }}
            >
              รายงานจัดอันดับลูกค้าอนาคต
            </div>,
            "indicator"
          ),
        ]
      ),
  ];

  const onClick = (e) => {
    setCurrent(e.key);
  };

  useEffect(() => {
    let pathArray = history.pathname.split("/");
    setCurrent(`/${pathArray[1]}`);

    if (history.pathname === "/") {
      setCollapsed(true);
    }
  }, [history.pathname]);

  useEffect(() => {
    setCurrent(currentTab);
  }, [currentTab]);

  return (
    <Sider
      width={280}
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => {
        setCollapsed(value);
      }}
      theme="light"
      className="relative"
    >
      <Menu
        mode="inline"
        onClick={onClick}
        theme="light"
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        defaultSelectedKeys={[current]}
        selectedKeys={[current]}
        items={items}
      />
      <div
        style={{
          color: "#A4A2A2",
          fontSize: 12,
          textAlign: "center",
          bottom: 50,
          position: "absolute",
          width: "100%",
        }}
      >
        Website Version {packageJson.version}
      </div>
    </Sider>
  );
};

export default Sidebar;
